<template>
<div>
    <Breadcrumbs main="Sales" title="Order Details" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div style="padding: 0px 12px; margin-bottom: 16px; display: flex; justify-content: end;">
            <b-button variant="primary" @click="goBack">
                <div style="display: flex; align-items: center; gap: 8px;">
                    <feather type="arrow-left" size="18px"></feather>
                    <h7>Back</h7>
                </div>
            </b-button>
        </div>
        <div class="row">
            <div class="col-md-12 mx-auto">
                <b-card class="order-card border-0">

                    <!-- Header -->
                    <div class="d-flex mb-2 justify-content-between align-items-center">
                        <div class="d-flex align-items-center" style="gap: 12px;">
                            <div class="avatar">
                                {{ detail.client.user_name.charAt(0) }}
                            </div>
                            <div>
                                <h5 class="mb-0 fw-bold">{{ detail.client.user_name }}</h5>
                                <small class="text-muted">Client</small>
                            </div>
                        </div>

                        <b-badge class="px-3 py-2 text-capitalize" :variant="getCollectionVariant(detail.collection_status)" pill>
                            {{ formatLabel(detail.collection_status) }}
                        </b-badge>
                    </div>

                    <!-- Fulfillment -->
                    <div class="p-3 mb-4 fulfillment-box">
                        <div class="d-flex mb-2 justify-content-between align-items-center">
                            <span class="fw-semibold">Fulfillment</span>
                            <b-badge class="px-2 py-1 text-capitalize" :variant="getFulfillmentVariant(detail.fulfillment_status.status)">
                                {{ formatLabel(detail.fulfillment_status.status) }}
                            </b-badge>
                        </div>

                        <!-- Progress -->
                        <b-progress height="10px" class="rounded-pill" :max="detail.fulfillment_status.total_ordered">
                            <b-progress-bar :value="detail.fulfillment_status.total_delivered" :variant="getFulfillmentVariant(detail.fulfillment_status.status)" />
                        </b-progress>

                        <small class="d-block mt-2 text-muted">
                            {{ detail.fulfillment_status.total_delivered }} /
                            {{ detail.fulfillment_status.total_ordered }} completed
                        </small>
                    </div>

                    <!-- Stats -->
                    <div class="row g-3 text-center">
                        <div class="col-md-4">
                            <div class="stat-box">
                                <i class="text-primary pi pi-shopping-cart stat-icon"></i>
                                <div class="stat-value">
                                    {{ detail.fulfillment_status.total_ordered }}
                                </div>
                                <small>Ordered</small>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="stat-box">
                                <i class="text-success pi pi-check-circle stat-icon"></i>
                                <div class="text-success stat-value">
                                    {{ detail.fulfillment_status.total_delivered }}
                                </div>
                                <small>Delivered</small>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="stat-box">
                                <i class="text-danger pi pi-clock stat-icon"></i>
                                <div class="text-danger stat-value">
                                    {{ detail.fulfillment_status.total_remaining }}
                                </div>
                                <small>Remaining</small>
                            </div>
                        </div>
                    </div>

                </b-card>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <px-card>
                    <div slot="with-padding">
                        <div class="d-flex flex-wrap flex-row custom-tabs">
                            <div class="tab-item" :class="{ active: activeTab === 'details' }" @click="changeTab('details')">
                                <p>Details</p>
                            </div>

                            <div class="tab-item" :class="{ active: activeTab === 'challans' }" @click="changeTab('challans')">
                                <p>Generated Challans</p>
                            </div>
                        </div>
                        <div class="form theme-form" v-if="activeTab === 'details'">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Quotation</label>
                                        <v-select class="custom-vue-select" :options="quotations" label="quotation_id" :reduce="quotation_id => quotation_id.id" v-model="order.quotation" placeholder="Select a quotation" disabled></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Project</label>                         
                                        <v-select class="custom-vue-select" :options="projects" label="title" :reduce="project => project.id" v-model="order.project" placeholder="Select a project" disabled></v-select>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Client</label>      
                                        <v-select class="custom-vue-select" :options="clients" label="company_name" :reduce="client => client.user.id" v-model="order.client" placeholder="Select a client" disabled></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Currency</label>
                                        <v-select class="custom-vue-select" :options="currencies" v-model="order.currency" placeholder="Select a currency" disabled></v-select>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Email</label>
                                        <input class="form-control" type="text" placeholder="Enter email address" v-model="order.email" disabled>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Client Address</label>
                                        <input class="form-control" type="text" placeholder="Enter client address" v-model="order.client_address" disabled>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Billing Address</label>
                                        <input class="form-control" type="text" placeholder="Enter billing address" v-model="order.billing_address" disabled>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Order Date</label>
                                        <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" v-model="order.order_date" disabled></datepicker>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Due Date</label>
                                        <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" v-model="order.due_date" disabled></datepicker>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-4 table-container" v-if="order.details && order.details.length > 0">
                                <div class="table-responsive detailtable-vue">
                                    <b-table show-empty :items="order.details" :fields="fields">
                                        <template #cell(name)="row">
                                            <h6 style="min-width: 150px;" v-if="row.item.checkLabel">{{ row.item.name }}</h6>
                                            <p style="min-width: 150px;" v-else>{{ row.item.name }}</p>
                                        </template>
                                        <template #cell(description)="row">
                                            <div v-if="row.item.description !== null">
                                                <p style="width: 400px; word-break: break-all;">{{ truncateText(row.item.description, 45) }}</p>
                                            </div>
                                        </template>

                                        <template #cell(amount)="row">
                                            <div v-if="row.item.rate">
                                                <p v-if="row.item.rate == 0"></p>
                                                <p v-else>{{ row.item.rate }}</p>
                                            </div>
                                        </template>
                                    </b-table>
                                </div>
                            </div>


                            <div class="row">
                                <div class="col-sm-4"></div>
                                <div class="col-sm-8">
                                    <!-- Total -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Total</label>
                                        <input class="form-control" type="number" placeholder="Enter total amount" disabled v-model="order.total" />
                                    </div>

                                    <!-- Vat -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Vat (%)</label>
                                        <div class="d-flex flex-lg-nowrap flex-wrap w-100" style="gap:16px">
                                            <div class="w-100">
                                                <select class="form-control digits" v-model="order.vat_type" disabled>
                                                    <option disabled value="">Select Vat Type</option>
                                                    <option v-for="(type, index) in vat_type" :key="index" :value="type.value">{{ type.title }}</option>
                                                </select>
                                                <small class="text-danger" v-if="errors.vat_type">{{ errors.vat_type }}</small>

                                            </div>

                                            <div class="w-100">
                                                <input class="form-control" type="number" placeholder="Enter vat (%)" v-model="order.vat" disabled />
                                                <small class="text-danger" v-if="errors.vat">{{ errors.vat }}</small>
                                            </div>
                                            <input class="form-control" type="number" placeholder="Vat Amount" v-model="vatAmount" disabled />
                                        </div>
                                    </div>

                                    <!--  Tax-->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Tax (%)</label>
                                        <div class="d-flex flex-lg-nowrap flex-wrap w-100" style="gap:16px">
                                            <div class="w-100">
                                                <select class="form-control digits" v-model="order.tax_type" disabled>
                                                    <option disabled value="">Select Tax Type</option>
                                                    <option v-for="(type, index) in vat_type" :key="index" :value="type.value">{{ type.title }}</option>
                                                </select>

                                                <small class="text-danger" v-if="errors.tax_type">{{ errors.tax_type }}</small>

                                            </div>

                                            <div class="w-100">
                                                <input class="form-control" type="number" placeholder="Enter tax (%)" v-model="order.tax" disabled />
                                                <small class="text-danger" v-if="errors.tax">{{ errors.tax }}</small>
                                            </div>
                                            <input class="form-control" type="number" placeholder="Tax Amount" v-model="taxAmount" disabled />
                                        </div>

                                    </div>
                                    <!-- Discount -->

                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Discount (%)</label>
                                        <div class="d-flex w-100" style="gap:16px">
                                            <input class="form-control w-50" type="number" placeholder="Enter discount (%)" v-model="order.discount" disabled />
                                            <input class="form-control w-50" type="number" placeholder="Tax Amount" v-model="discountAmount" disabled />
                                        </div>
                                    </div>

                                    <!-- Grand Total -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Grand Total ({{ order.currency ? order.currency : "BDT" }})</label>
                                        <input class="form-control" type="number" placeholder="Enter grand total" disabled v-model="order.subtotal" />
                                    </div>

                                    <!-- In Words -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">In Words</label>
                                        <input class="form-control" type="text" placeholder="Enter grand total in words" v-model="order.in_words" disabled />
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Remarks</label>
                                        <textarea class="form-control" id="exampleFormControlTextarea4" placeholder="Enter remarks..." rows="2" v-model="order.remarks" disabled></textarea>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div v-if="activeTab === 'challans'">
                        <b-table show-empty :items="challans" borderless  responsive :fields="tablefields" :per-page="perPage" :current-page="currentPage" :filter="filter" @filtered="onFiltered" class="dispatch-table" >
                            <template #cell(index)="data">
                                <div class="dispatch-index">
                                    {{ (currentPage - 1) * perPage + data.index + 1 }}
                                </div>
                            </template>

                            <template #cell(challan)="data">
                                <div class="d-flex flex-column" style="gap: 4px;">
                                    <router-link :to="`/sales/challan-details/${data.item.id}`">
                                        <div class="link-style">{{ data.item.challan_id }}</div>
                                    </router-link>
                                    <small>Company: {{ data.item?.client?.additional_info?.company_name }}</small>
                                    <small class="text-muted" v-if="data.item?.client?.first_name">{{ data.item?.client?.first_name }}</small>
                                   
                                </div>
                            </template>

                            <template #cell(amount)="data">
                                <strong>৳ {{ formatNumber(data.item?.invoice?.total) }}</strong>
                            </template>

                            <template #cell(status)="data">
                                <b-badge :variant="statusVariant(data.item.delivery_status)" class="text-uppercase">
                                    {{ data.item.delivery_status }}
                                </b-badge>
                            </template>
                            <template #cell(location)="data">
                                <small>{{ data.item?.delivery_address ?? 'N/A' }}</small>
                            </template>

                            <!-- <template #cell(action)="data">
                                <div class="d-flex align-items-center action-group" style="gap: 10px;">
                                    <feather type="delete" size="18px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteChallan(data.item.id)" title="Delete"></feather>
                                </div>
                            </template> -->

                        </b-table>

                        <!-- Pagination -->
                        <div class="d-flex flex-wrap mt-2 px-2 align-items-center" style="gap: 24px;">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" size="sm"></b-pagination>
                            <b-form-select v-model="perPage" :options="pageOptions" size="sm" style="width: 100px;"></b-form-select>
                        </div>
                        </div>
                    </div>
                </px-card>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->



 
    <!-- Delete Challan -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this Challan?</div>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import Datepicker from 'vuejs-datepicker';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import {
    computed
} from "vue";
import ItemTable from "../items-table/edit-item-table.vue";
import moment from "moment";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import {
    toWords
} from 'number-to-words'
export default {
    components: {
        vueDropzone: vue2Dropzone,
        Datepicker,
        ItemTable,
        'v-select': vSelect
    },

    data() {
        return {
            fields: [{
                    key: 'name',
                    label: 'Item',
                    sortable: false
                },
                {
                    key: 'description',
                    label: 'Description',
                    sortable: false
                },

                {
                    key: 'unit_price',
                    label: 'Unit Price',
                    sortable: false
                },
                {
                    key: 'quantity',
                    label: 'Quantity',
                    sortable: false
                },
                {
                    key: 'amount',
                    label: 'Amount',
                    sortable: false
                }
            ],

            discountAmount: computed(() => {
                if (this.order.total !== 0) {
                    const discount = this.order.discount || 0;
                    let total = this.order.total + discount * (this.order.total / 100)
                    let gtotal = total - this.order.total

                    return Math.round((gtotal + Number.EPSILON) * 100) / 100;
                }
                return 0;
            }),
            basePrice: computed(() => {
                if (!this.order ?.total || !this.order ?.vat_type || !this.order ?.tax_type) return 0;

                const total = Number(this.order.total);
                const vat = Number(this.order.vat || 0);
                const tax = Number(this.order.tax || 0);

                if (this.order.vat_type === 'inclusive' && this.order.tax_type === 'inclusive') {
                    const divisor = 1 + (vat + tax) / 100;
                    const base = total / divisor;
                    return Math.round((base + Number.EPSILON) * 100) / 100;
                }

                let divisor = 1;
                if (this.order.vat_type === 'inclusive') {
                    divisor += vat / 100;
                }
                if (this.order.tax_type === 'inclusive') {
                    divisor += tax / 100;
                }

                const base = total / divisor;
                return Math.round((base + Number.EPSILON) * 100) / 100;
            }),

            taxAmount: computed(() => {
                if (this.order ?.tax && this.order ?.tax_type && this.order ?.total) {
                    const vat = Number(this.order.tax);
                    return Math.round((this.basePrice * vat / 100 + Number.EPSILON) * 100) / 100;
                }

                return 0;
            }),

            vatAmount: computed(() => {
                if (this.order ?.vat && this.order ?.vat_type && this.order ?.total) {
                    const vat = Number(this.order.vat);
                    return Math.round((this.basePrice * vat / 100 + Number.EPSILON) * 100) / 100;
                }

                return 0;
            }),
            order: {
                quotation: null,
                project: null,
                email: '',
                currency: '',
                order_attachment: null,
                client_address: '',
                client: '',
                billing_address: '',
                order_date: null,
                due_date: null,
                details: null,
                details_in_depth: [],

                total: computed(() => {
                    let total = 0;
                    if (this.order.details_in_depth.length >= 1) {
                        this.order.details_in_depth.map((item) => {
                            total = total + item.rate;
                        });
                    }
                    return total;
                }),
                tax: null,
                vat: null,
                vat_type: '',
                tax_type: '',
                discount: null,
                subtotal: computed(() => {
                    if (!this.order ?.total || !this.order ?.vat_type || !this.order ?.tax_type) return 0;

                    const total = Number(this.order.total);
                    const discount = Number(this.order.discount || 0);

                    // Case 1: both VAT and TAX are inclusive → just apply discount to total
                    if (this.order.vat_type === 'inclusive' && this.order.tax_type === 'inclusive') {
                        const discounted = total - (total * discount / 100);
                        return Math.round((discounted + Number.EPSILON) * 100) / 100;
                    }

                    // Case 2: Exclusive taxes → add them first
                    let calculated = total;

                    if (this.order.vat_type === 'exclusive') {
                        calculated += this.vatAmount;
                    }

                    if (this.order.tax_type === 'exclusive') {
                        calculated += this.taxAmount;
                    }

                    // Apply discount to final calculated total
                    const discounted = calculated - (calculated * discount / 100);
                    return Math.round((discounted + Number.EPSILON) * 100) / 100;
                }),
                order_attachment: null,
                in_words: '',
                remarks: ''
            },

            client: {
                name: '',
                company: '',
                designation: '',
                phone: '',
                email: '',
                address: '',
                status: true
            },

            nameState: null,

            company: {
                name: '',
                email: '',
                website: '',
                address: '',
                bin: '',
                tin: ''
            },

            vat_type: [{
                    id: 1,
                    value: "inclusive",
                    title: "Inclusive",
                },
                {
                    id: 2,
                    value: "exclusive",
                    title: "Exclusive",
                }
            ],
            errors: {
                vat_type: '',
                tax_type: '',
                tax: '',
                vat: '',
            },

            currencies: ['BDT', 'USD', 'EUR'],
            activeTab: 'details',
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'challan',
                    label: 'Challan'
                },
                {
                    key: 'location',
                    label: 'Location'
                },
                {
                    key: 'amount',
                    label: 'Amount'
                },
                {
                    key: 'status',
                    label: 'Status'
                },
            ],
            totalRows: 0,
            currentPage: 1,
            perPage: 5,
            pageOptions: [5, 10, 20],
            filter: '',
            delete_value: null,
        };
    },

    computed: {
        ...mapState({
            detail: state => state.order.order_detail,
            items: state => state.item.items,
            projects: state => state.project.project,
            quotations: state => state.quotation.quotation_withoutpg,
            clients: state => state.client.client_without_pg,
            companies: state => state.client.company,
            challans: state => state.order.sales_fulfillment,
        })
    },

    mounted() {
        this.$store.dispatch("order/fetchOrderDetail", this.$route.params.id).then(response =>{
            this.$store.dispatch("order/fetchFulfillment", {order: response?.data?.id} ).then((response) => {
                this.totalRows = response.data.length;

            });
        })
        this.$store.dispatch("item/fetchItem")
        this.$store.dispatch("project/fetchProject")
        this.$store.dispatch("quotation/fetchQuotationWithoutPG")
        this.$store.dispatch("client/fetchClient_without_pg")
        this.$store.dispatch("client/fetchCompany");
       
                
    },

    watch: {
        detail(oldValue, newValue) {
            this.order.quotation = this.detail ?.quotation ?.id ?? null
            this.order.project = this.detail ?.project ?.id ?? null
            this.order.email = this.detail ?.email ?? null
            this.order.currency = this.detail ?.currency ?? null
            this.order.client_address = this.detail ?.client_address ?? null
            this.order.billing_address = this.detail ?.billing_address ?? null
            this.order.order_date = this.detail ?.order_date ?? null
            this.order.due_date = this.detail ?.due_date ?? null
            this.order.client = this.detail ?.client ?.id ?? null
            this.order.order_attachment = this.detail ?.order_attachment ?? null

            this.order.details = this.detail.details ? JSON.parse(this.detail.details) : null
            this.order.details_in_depth = this.order.details

            this.order.total = this.detail ?.total ?? null
            this.order.vat = this.detail ?.vat ?? null
            this.order.tax = this.detail ?.tax ?? null
            this.order.vat_type = this.detail ?.vat_type ?? null
            this.order.tax_type = this.detail ?.tax_type ?? null

            this.order.discount = this.detail ?.discount ?? null
            this.order.subtotal = this.detail ?.subtotal ?? null
            this.order.in_words = this.detail ?.in_words ?? null
            this.order.remarks = this.detail ?.remarks ?? null
        },

        'order.quotation'(newVal) {
            if (newVal !== null) {
                this.order.project = null
            } else {
                this.order.project = this.detail.project ? this.detail.project.id : null
            }
        },
        'order.subtotal'(val) {
            if (!val) {
                this.order.in_words = ''
                return
            }

            const text = toWords(val)
            this.order.in_words = text.replace(/\b\w/g, c => c.toUpperCase())
        }
    },

    methods: {
        formatNumber(value) {
            return Number(value || 0).toLocaleString();
        },
        statusVariant(status) {
            if (status === 'READY') return 'success'
            if (status === 'BLOCKED') return 'danger'
            if (status === 'PARTIAL') return 'warning'
            return 'secondary'
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        changeTab(tab) {
            this.activeTab = tab
        },
        goBack() {
            if (window.history.length > 1) {
                this.$router.back();
            } else {
                this.$router.push('/dashboard');
            }
        },

        getFulfillmentVariant(status) {
            const map = {
                full: "success",
                partial: "warning",

            };
            return map[status] || "secondary";
        },
        getCollectionVariant(status) {
            const map = {
                paid: "success",
                unpaid: "danger",
                no_invoice: "secondary",
                partial: "warning"
            };
            return map[status] || "secondary";
        },
        formatLabel(value) {
            return value.replace("_", " ").toUpperCase();
        },
        truncateText(text, maxLength) {
            if (text.length > maxLength) {
                return text.substring(0, maxLength) + '...';
            } else {
                return text;
            }
        },

      


        updateItems(data) {
            console.log(data)
            if (data) {
                this.order.details = data;
                this.order.details_in_depth = data;
            }
        },

    

        deleteChallan(id) {
            this.delete_value = id
        },
        handleDeleteOk() {
            this.$store.dispatch("order/deleteChallan", {
                id: this.delete_value,
                order_id: this.$route.params.id
                
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },
    }
};
</script>

<style scoped>
.order-card {
    border-radius: 16px;
    padding: 10px 8px;
    background: linear-gradient(145deg, #ffffff, #f8f9fa);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
    transition: all 0.25s ease;
}

.order-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.08);
}

/* Avatar */
.avatar {
    width: 45px;
    height: 45px;
    background: #4f46e5;
    color: white;
    font-weight: bold;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Fulfillment box */
.fulfillment-box {
    background: #f9fafb;
    border-radius: 12px;
}

/* Stats */
.stat-box {
    background: #ffffff;
    border-radius: 12px;
    padding: 15px;
    transition: 0.2s;
    border: 1px solid #f1f1f1;
}

.stat-box:hover {
    transform: scale(1.03);
}

.stat-icon {
    font-size: 20px;
    margin-bottom: 5px;
}

.stat-value {
    font-size: 20px;
    font-weight: 600;
}

/* Tabs */
.custom-tabs {
    gap: 10px;
    /* border-bottom: 1px solid #e5e7eb; */
    padding-bottom: 24px;
}

.tab-item {
    padding: 10px 20px;
    cursor: pointer;
    border-radius: 8px;
    transition: 0.3s ease;
    background-color: #f3f4f6;
}

.tab-item p {
    margin: 0;
    font-weight: 600;
    color: #374151;
}

.tab-item:hover {
    background-color: #e5e7eb;
}

.tab-item.active {
    background-color: #4f46e5;
}

.tab-item.active p {
    color: white;
}
</style>
